import { render, staticRenderFns } from "./pc-sheet.vue?vue&type=template&id=f3e4076c&scoped=true&"
import script from "./pc-sheet.vue?vue&type=script&lang=ts&"
export * from "./pc-sheet.vue?vue&type=script&lang=ts&"
import style0 from "./pc-sheet.vue?vue&type=style&index=0&id=f3e4076c&lang=less&scoped=true&"
import style1 from "./pc-sheet.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e4076c",
  null
  
)

export default component.exports